import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { registerLocaleData } from "@angular/common";
import { LOCALE_ID } from "@angular/core";
import locale_en from '@angular/common/locales/en';
import locale_ar_sa from '@angular/common/locales/ar-SA';
import locale_es_419 from '@angular/common/locales/es-419';
import locale_fr from '@angular/common/locales/fr';
import locale_he_il from '@angular/common/locales/he';
import locale_it_it from '@angular/common/locales/it';
import locale_en_au from '@angular/common/locales/en-AU';
import locale_pt from '@angular/common/locales/pt';
import {TranslateService} from '@ngx-translate/core';
import { STUDENT_WINDOW } from './students.types';

declare var window:any;

registerLocaleDataForAngular(window.LOCALE);

@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    providers: [{ provide: LOCALE_ID, useValue: window.LOCALE }],
    standalone: false
})

export class AppComponent {
    constructor(private translate: TranslateService) {
        let languages = ['ar_sa', 'en_au', 'es_419', 'fr', 'he_il', 'it_it', 'pt_br'];
        if (languages.indexOf(window.LANGPACK) > -1) {
            translate.setDefaultLang(window.LANGPACK);
            translate.use(window.LANGPACK);
        } else {
            translate.setDefaultLang('en');
            translate.use('en');
        }

    }
}

function registerLocaleDataForAngular(locale)
{
    switch (locale) {
        case 'ar_sa':
            registerLocaleData(locale_ar_sa, 'ar_sa');
            break;
        case 'en_au':
            registerLocaleData(locale_en_au, 'en_au');
            break;
        case 'es_419':
            registerLocaleData(locale_es_419, 'es_419');
            break;
        case 'fr':
            registerLocaleData(locale_fr, 'fr');
            break;
        case 'he_il':
            registerLocaleData(locale_he_il, 'he_il');
            break;
        case 'it_it':
            registerLocaleData(locale_it_it, 'it_it');
            break;
        case 'pt_br':
            registerLocaleData(locale_pt, 'pt_br');
            break;
        default:
            registerLocaleData(locale_en, locale);
            break;
    }
}
